import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SmsAggregator } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { Validator } from 'src/app/core/constants/validators';
import { ConsoleService } from 'src/app/core/services/console.service';
import { GetEnumValuesDto } from '../../../../core/api/models/get-enum-values-dto';
import { AggregatorsService } from '../../../../core/api/services/aggregators.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";

@Component({
    selector: 'app-number-aggregator',
    templateUrl: './number-aggregator.component.html',
    imports: [BaseFormModule, ModalTitleComponent]
})
export class NumberAggregatorComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  mobile = '';
  aggregator = null;
  SmsAggregatorsEnumValues: GetEnumValuesDto[] = [];
  get SmsAggregator() {
    return SmsAggregator;
  }
  //#endregion

  constructor(
    protected currentService: AggregatorsService,
    private dialogRef: MatDialogRef<NumberAggregatorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.SmsAggregatorsEnumValues = data?.smsAggregatorsEnum;
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      mobile: new FormControl('', Validator.mobile),
    });
  }

  //#region Api

  getNumberAggregator() {
    this.unSubs();
    this.loading = true;
    this.currentService
      .aggregatorsGetNumberAggregator({ mobile: this.mobile })
      .pipe(this.basePipeOperators())
      .subscribe(
        (result) => {
          this.aggregator = result?.data;
          this.unSubs();
        },
        () => (this.loading = false)
      );
  }

  //#endregion

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  convertMobile() {
    // this.mobile = this.mobile.convertMobileNumberPrefixTo98().trim();
  }

  onSubmit() {
    try {
      if (this.loading) return;
      if (!this.isValidForm(this.form, this.tagName)) return;

      try {
        this.getNumberAggregator();
      } catch (error) {
        ConsoleService.error('error', error);
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  getSmsAggregatorImg(aggregators: SmsAggregator): string {
    try {
      let imgSrc = '';
      switch (aggregators) {
        case SmsAggregator.MCI:
          imgSrc = '/assets/media/svg/operator/mci.svg';
          break;
        case SmsAggregator.Irancell:
          imgSrc = '/assets/media/svg/operator/mtn.svg';
          break;
        case SmsAggregator.Rightel:
          imgSrc = '/assets/media/svg/operator/rightel.svg';
          break;
        case SmsAggregator.NotValid:
          imgSrc = '/assets/media/icons/duotune/general/gen034.svg';
          break;
        case SmsAggregator.Other:
          imgSrc = '/assets/media/icons/duotune/general/gen023.svg';
          break;
        default:
          break;
      }
      return imgSrc;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  getSmsAggregatorImgWidth(aggregator: SmsAggregator): string {
    try {
      let imgWidth = '';
      switch (aggregator) {
        case SmsAggregator.MCI:
          imgWidth = '30';
          break;
        case SmsAggregator.Irancell:
          imgWidth = '30';
          break;
        case SmsAggregator.Rightel:
          imgWidth = '60';
          break;
        case SmsAggregator.NotValid:
          imgWidth = '30';
          break;
        case SmsAggregator.Other:
          imgWidth = '30';
          break;
        default:
          break;
      }
      return imgWidth;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
}
